import React from 'react';
import cx from 'classnames';

import { BlockWrapper } from '../blockWrapper';
import { PortableTextBlock } from '@modules/portableTextBlock';

const TextBlock = ({
  _rawText,
  centerText,
  blockConfig,
  layout,
  whiteText,
}) => {
  return (
    <BlockWrapper
      className={`prose md:prose-lg max-w-none grid grid-cols-14 ${
        centerText && 'text-center'
      }`}
      {...blockConfig}>
      <div
        className={cx('col-start-2 col-end-14', {
          'lg:col-end-11': layout === 'left',
          'lg:col-start-5 text-right': layout === 'right',
          'text-center': layout === 'full',
          'lg:col-start-4 lg:col-end-12': layout === 'center',
          'lg:col-end-9': layout === 'drop-left',
          'text-white bullet-white': whiteText,
          'text-black': !whiteText,
        })}>
        <PortableTextBlock text={_rawText} />
      </div>
    </BlockWrapper>
  );
};

export default TextBlock;
